import { HttpRequest} from 'utils/'
const state = {
    tabSelect:null
}

const mutations = {
    setTabSelect(state,tabSelect) {
        state.tabSelect = tabSelect
    }
}

const actions = {
  getTabSelect({ commit },data) {
   HttpRequest({
       url:'/professional/get_category_list/',
       params: data
   }).then(res=>{
       commit('setTabSelect',res.results)
   })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}